import React from 'react';
import useBusinessGuard from '../../../../hooks/useBusinessGuard';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAirConditioningCategory,
  AddAirConditioningListing,
  AddMedia,
  getAirConditioningListing,
  UpdateAirConditioningListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import MapModal from '../../../common/Modal/MapModel';
import LogoCropModal from '../../../common/Modal/LogoCropModal';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import Swal from 'sweetalert2';
import { sanitizeWhatsAppFields } from '../../../../utils/sanitizeWhatsApp';

const AirConditioningBusiness = () => {
  const { t } = useTranslation();
  const home = useSelector((state) => state.home);
  const Categorylist = home?.getCategoryList;
  const getAirConditioningList = home?.getAirConditioningList;
  const getMybusiness = home?.getMybusiness;
  const [mapModalOpen, setMapModalOpen] = useState(false);

  const dispatch = useDispatch();

  // One business per account: redirect if the user already owns a
  // different business instead of failing this add-form on save.
  useBusinessGuard('CAR12');

  // The owner's business id can arrive two ways after a reload: from Redux
  // (getMybusiness, set once /business/my resolves) or from sessionStorage.
  // Prefer whichever is available and refetch the owner's OWN business as soon
  // as the id is known — fixes the blank form after creating a business.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  useEffect(() => {
    dispatch(getAirConditioningCategory());
  }, []);

  useEffect(() => {
    if (validBid) {
      dispatch(getAirConditioningListing(ownerBid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'all' });

  console.log('getAirConditioningList', getAirConditioningList);

  const [ImageLogo, setImageLogo] = useState({
    selectedFile: '',
  });
  const [ImageBlob, setImageBlob] = useState({ blob: '' });
  // Cropper state: { src, name } of the just-picked image, shown in the modal.
  const [cropSrc, setCropSrc] = useState(null);
  const [cropName, setCropName] = useState('');
  // Additional phone numbers beyond the primary phone + whatsapp. Each entry is
  // { countryCode, mobileNumber }. Appended to mobileNumbers on submit.
  const [extraPhones, setExtraPhones] = useState([]);
  const addExtraPhone = () =>
    setExtraPhones((p) => [...p, { countryCode: '+965', mobileNumber: '' }]);
  const removeExtraPhone = (i) =>
    setExtraPhones((p) => p.filter((_, idx) => idx !== i));
  const updateExtraPhone = (i, key, value) =>
    setExtraPhones((p) =>
      p.map((row, idx) => (idx === i ? { ...row, [key]: value } : row))
    );

  const [AirConditioningData, setAirConditioningData] = useState({
    airConditioningName: '',
    about: '',
    category: '',
    mobileNumberCountryCode: '+965',
    mobileNumber: '',
    whatsAppNumberCountryCode: '+965',
    whatsAppNumber: '',
    mobileNumbers: [
      {
        countryCode: '+965',
        mobileNumber: '',
      },
    ],
    location: '',
    gps: {
      lat: '12.001',
      long: '34.113',
    },
    website: '',
    socialMedia: {
      FACEBOOK: '',
      SNAPCHAT: '',
      INSTAGRAM: '',
      YOUTUBE: '',
      LINKEDIN: '',
      TWITTER: '',
    },
    mediaIds: {
      LOGO: [''],
    },
  });

  useEffect(() => {
    if (getAirConditioningList?.length) {
      const gps =
        typeof getAirConditioningList?.[0]?.gps === 'string'
          ? JSON.parse(getAirConditioningList?.[0]?.gps)
          : getAirConditioningList?.[0]?.gps;

      const socialMedia =
        typeof getAirConditioningList?.[0]?.socialMedia === 'string'
          ? JSON.parse(getAirConditioningList?.[0]?.socialMedia)
          : getAirConditioningList?.[0]?.socialMedia;
      setAirConditioningData({
        airConditioningName: getAirConditioningList?.[0]?.airConditioningName,
        about: getAirConditioningList?.[0]?.about,
        category: getAirConditioningList?.[0]?.category,
        mobileNumberCountryCode:
          getAirConditioningList?.[0]?.mobileNumberCountryCode,
        mobileNumber: getAirConditioningList?.[0]?.mobileNumber,
        mobileNumbers: [
          {
            countryCode: '',
            mobileNumber: '',
          },
        ],
        location: getAirConditioningList?.[0]?.location,
        gps: {
          lat: gps?.lat,
          long: gps?.long,
        },
        website: getAirConditioningList?.[0]?.website,
        socialMedia: {
          FACEBOOK: socialMedia.FACEBOOK,
          SNAPCHAT: socialMedia.SNAPCHAT,
          INSTAGRAM: socialMedia.INSTAGRAM,
          YOUTUBE: socialMedia.YOUTUBE,
          LINKEDIN: socialMedia.LINKEDIN,
          TWITTER: socialMedia.TWITTER,
        },
        mediaIds: {
          LOGO: [
            getAirConditioningList?.[0]?.businessMedia?.[0]?.media?.mediaId,
          ],
        },
      });
      setImageBlob({
        blob: getAirConditioningList?.[0]?.businessMedia?.[0]?.media?.path,
      });

      // Load any saved numbers beyond the first two (phone + whatsapp) into the
      // additional-phones editor so they show up and can be edited.
      const _savedNums = getAirConditioningList?.[0]?.mobileNumbers;
      if (Array.isArray(_savedNums) && _savedNums.length > 2) {
        setExtraPhones(
          _savedNums.slice(2).map((n) => ({
            countryCode: n?.countryCode || '+965',
            mobileNumber: n?.mobileNumber || '',
          }))
        );
      }

      // Sync prefilled required fields into react-hook-form. Inputs are
      // controlled by state, but RHF only tracks values entered through its own
      // onChange — without this a prefilled form fails validation on submit
      // ("required") even though the fields are visibly filled.
      setValue(
        'airConditioningName',
        getAirConditioningList?.[0]?.airConditioningName || '',
        { shouldValidate: true }
      );
      setValue('mobileNumber', getAirConditioningList?.[0]?.mobileNumber || '', {
        shouldValidate: true,
      });
      setValue(
        'whatsAppNumber',
        getAirConditioningList?.[0]?.whatsAppNumber || '',
        { shouldValidate: true }
      );
    }
  }, [getAirConditioningList]);

  function handleChange(e) {
    const { name, value } = e.target;
    console.log(name, value);

    setAirConditioningData((user) => ({ ...user, [name]: value }));
  }
  const mediaChange = (e) => {
    setAirConditioningData({
      ...AirConditioningData,
      socialMedia: {
        ...AirConditioningData.socialMedia,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleUploadImage = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate: must be an image, and within a sane size limit
    if (!file.type || !file.type.startsWith('image/')) {
      Swal.fire({
        title: 'Invalid file',
        text: 'Please upload an image file (JPG, PNG, etc.).',
        icon: 'error',
      });
      event.target.value = '';
      return;
    }
    const MAX_MB = 12;
    if (file.size > MAX_MB * 1024 * 1024) {
      Swal.fire({
        title: 'Image too large',
        text: `Please upload an image smaller than ${MAX_MB} MB.`,
        icon: 'error',
      });
      event.target.value = '';
      return;
    }

    // Load the picked image and open the cropper modal. The owner frames the
    // logo in a square; the cropped, compressed JPEG is uploaded on Apply.
    const reader = new FileReader();
    reader.onload = (ev) => {
      setCropName(file.name || 'logo');
      setCropSrc(ev.target.result);
    };
    reader.readAsDataURL(file);
    // Allow re-picking the same file later.
    event.target.value = '';
  };

  // Upload a cropped square logo (called by the cropper modal's Apply button).
  const uploadCroppedLogo = (result) => {
    setCropSrc(null);
    if (!result || !result.file) return;
    setImageLogo({ selectedFile: result.file });
    // The preview <img> reads ImageBlob.blob, so wrap the data URL in { blob }
    // (same shape the prefill uses) — otherwise the cropped image won't show.
    if (result.preview) setImageBlob({ blob: result.preview });
    const formData = new FormData();
    formData.append('media', result.file);
    // silent: the inline preview is the confirmation, so no success popup.
    pendingLogoUploadRef.current = true;
    dispatch(AddMedia({ formData, silent: true }));
  };

  const pendingLogoUploadRef = useRef(false);
  /* [CF 2026-08-11] The uploaded logo id arrives asynchronously in the
     `[counter]` effect below, but TWO other effects (the prefill and the
     mobileNumbers rebuild) also call setState with their own stale snapshot of
     this object — either can drop the fresh LOGO id before the form is
     submitted, and the save then re-sends the OLD id, which the owner sees as
     "the logo did not change". The ref is written the instant the upload
     resolves and is applied again at submit time, so it cannot be clobbered. */
  const logoIdRef = useRef(null);
  const counter = useSelector((state) => state.home.AddMediaList);
  console.log('useSelecter ', counter);
  /* [CF 2026-08-09 #18] `home.AddMediaList` is a GLOBAL redux slot written by
     every media upload anywhere in the app, and nothing ever clears it. This
     effect therefore also fired on MOUNT, off whatever the last upload had
     left behind, silently stamping the PREVIOUS company's logo id into this
     form — save it and that company's logo came back, which is the "updating
     one company's logo reverts the other one" report. Consume the slot only
     when THIS page actually started an upload; same guard the `*Banner.js`
     screens already carry as `pendingUploadRef`. */
  useEffect(() => {
    if (!pendingLogoUploadRef.current) return;
    pendingLogoUploadRef.current = false;
    console.log('hellow ', counter);
    if (counter !== undefined) {
      const logoid = counter?.data?.response?.media[0]?.mediaId;
      logoIdRef.current = logoid;
      console.log('logoid', logoid);

      setAirConditioningData({
        ...AirConditioningData,
        mediaIds: {
          ...AirConditioningData.mediaIds,
          LOGO: [logoid],
        },
      });
    }
  }, [counter]);

  useEffect(() => {
    setAirConditioningData({
      ...AirConditioningData,
      mobileNumbers: [
        {
          countryCode: AirConditioningData.mobileNumberCountryCode,
          mobileNumber: AirConditioningData.mobileNumber,
        },
        {
          countryCode: AirConditioningData.whatsAppNumberCountryCode,
          mobileNumber: AirConditioningData.whatsAppNumber,
        },
      ],
    });
  }, [
    AirConditioningData.mobileNumberCountryCode,
    AirConditioningData.mobileNumber,
    AirConditioningData.whatsAppNumberCountryCode,
    AirConditioningData.whatsAppNumber,
  ]);

  const datasubmit = () => {
    // Append filled-in additional phone numbers to the primary phone + whatsapp
    // entries already built in AirConditioningData.mobileNumbers.
    const _extra = extraPhones.filter(
      (p) => p.mobileNumber && String(p.mobileNumber).trim()
    );
    const _payload = sanitizeWhatsAppFields({
      ...AirConditioningData,
      mobileNumbers: [
        ...(AirConditioningData.mobileNumbers || []),
        ..._extra,
      ],
    });
    if (logoIdRef.current) {
      _payload.mediaIds = {
        ..._payload.mediaIds,
        LOGO: [logoIdRef.current],
      };
    }
    if (getAirConditioningList?.length) {
      dispatch(UpdateAirConditioningListing(_payload));
    } else {
      dispatch(AddAirConditioningListing(_payload));
    }
  };
  const ResetHendler = () => {
    reset();
    setAirConditioningData({
      airConditioningName: '', about: '', category: '', mobileNumberCountryCode: '+965', mobileNumber: '',
      whatsAppNumberCountryCode: '+965', whatsAppNumber: '',
      mobileNumbers: [{ countryCode: '+965', mobileNumber: '' }],
      location: '', gps: { lat: '', long: '' }, website: '',
      socialMedia: { FACEBOOK: '', SNAPCHAT: '', INSTAGRAM: '', YOUTUBE: '', LINKEDIN: '', TWITTER: '' },
      mediaIds: { LOGO: [''] },
    });
    setImageLogo({ selectedFile: '' });
  };

  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-air-conditioning-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/sp-air-conditioning-services',
      label: t('Manage Service'),
    },
    {
      icon: 'assets/images/icons/sp-business/banner.svg',
      link: '/sp-air-conditioning-banner',
      label: t('Banner'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-working-hours.svg',
      link: '/sp-air-conditioning-working-hours',
      label: t('Manage Working Hours'),
    },
  ];

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  // Close map modal
  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  // Handle location selection from map
  const handleLocationSelect = (location) => {
    console.log(location);

    setAirConditioningData({
      ...AirConditioningData,
      location: location.address,
      gps: {
        lat: location.lat,
        long: location.long,
      },
    });
  };

  return (
    <div>
      <CommonBusinessHeader
        dataList={getAirConditioningList}
        getNameKey="airConditioningName"
      />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            <Sidebar options={sideBarOpt} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2>{t('Manage Business')}</h2>

              <form onSubmit={handleSubmit(datasubmit)}>
                <div class="form-group">
                  <label for="g-mb-business-name">{t('Business Name')}</label>
                  <input
                    {...register('airConditioningName', {
                      required: t('This field is required'),
                      minLength: {
                        value: 4,
                        message: t(
                          'Business Name should be minimum  4 characters'
                        ),
                      },
                      // pattern: {
                      // 	value: /^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){6,18}[a-zA-Z0-9]$/,
                      // 	message:
                      // 		'username can only use letters,numbers, minimum length is 6 characters',
                      // },
                    })}
                    name="airConditioningName"
                    value={AirConditioningData.airConditioningName}
                    onChange={handleChange}
                    type="text"
                    className={classNames('form-control', {
                      'is-invalid': errors.airConditioningName,
                    })}
                    id="g-mb-business-name"
                    placeholder={t('Business Name')}
                  />
                  {errors.airConditioningName && (
                    <p className="invalid-feedback">
                      {errors.airConditioningName.message}
                    </p>
                  )}
                </div>

                <div class="form-group">
                  <label>{t('Business Logo Image')}</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                            objectFit: 'cover',
                            border: '1px solid #e3e3e3',
                            background: '#f7f7f7',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={
                            ImageBlob.blob
                              ? ImageBlob.blob
                              : 'assets/images/camera.jpg'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="files"
                        >
                          {t('Upload Logo image')}
                        </label>
                        <input
                          type="file"
                          id="files"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="g-mb-phone-number">{t('Phone Number')}</label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="mobileNumberCountryCode"
                        value={AirConditioningData.mobileNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option value="">{t('Country Code')}</option>
                        <option value="+965">+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        {...register('mobileNumber', {
                          required: t('This field is required'),
                          pattern: {
                            value: /^\d{8}$/,
                            message: t(
                              'please enter a valid 8-digit phone number'
                            ),
                          },
                        })}
                        name="mobileNumber"
                        value={AirConditioningData.mobileNumber}
                        onChange={handleChange}
                        type="tel"
                        className={classNames('form-control', {
                          'is-invalid': errors.mobileNumber,
                        })}
                        id="g-mb-phone-number"
                        placeholder={t('Phone Number')}
                      />
                      {errors.mobileNumber && (
                        <p className="invalid-feedback">
                          {errors.mobileNumber.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="g-mb-whatsApp-number">
                    {t('WhatsApp Number')} <small>({t('Optional')})</small>
                  </label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="whatsAppNumberCountryCode"
                        value={AirConditioningData.whatsAppNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option value="">{t('Country Code')}</option>
                        <option value="+965">+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        {...register('whatsAppNumber', {
                          // required: 'this field is requerd',
                          pattern: {
                            value: /^\d{8}$/,
                            message: t(
                              'please enter a valid 8-digit whatsApp number'
                            ),
                          },
                        })}
                        name="whatsAppNumber"
                        value={AirConditioningData.whatsAppNumber}
                        onChange={handleChange}
                        type="tel"
                        className={classNames('form-control', {
                          'is-invalid': errors.whatsAppNumber,
                        })}
                        id="g-mb-whatsApp-number"
                        placeholder={t("WhatsApp Number")}
                      />
                      {errors.whatsAppNumber && (
                        <p className="invalid-feedback">
                          {errors.whatsAppNumber.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    {t('Additional Phone Numbers')}{' '}
                    <small>({t('Optional')})</small>
                  </label>
                  {extraPhones.map((phone, idx) => (
                    <div class="row" key={idx} style={{ marginBottom: '8px' }}>
                      <div class="col-4">
                        <select
                          class="form-control"
                          value={phone.countryCode}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'countryCode', e.target.value)
                          }
                        >
                          <option value="+965">+965</option>
                        </select>
                      </div>
                      <div class="col-7">
                        <input
                          type="tel"
                          inputMode="numeric"
                          class="form-control"
                          value={phone.mobileNumber}
                          placeholder={t('Phone Number')}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'mobileNumber', e.target.value)
                          }
                        />
                      </div>
                      <div class="col-1 px-0">
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-block"
                          title={t('Remove')}
                          onClick={() => removeExtraPhone(idx)}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    onClick={addExtraPhone}
                  >
                    + {t('Add phone number')}
                  </button>
                </div>

                {/* <div class="form-group">
                  <label for="g-mb-business-category">
                    {t('Business Category')}
                  </label>
                  <select
                    class="form-control"
                    id="g-mb-business-category"
                    name="category"
                    value={AirConditioningData.category}
                    onChange={handleChange}
                  >
                    <option>
                      {AirConditioningData?.category || t('Select Category')}
                    </option>
                    {Categorylist !== undefined && Categorylist.length > 0
                      ? Categorylist.map((x) => {
                          console.log(x);
                          return (
                            <option value={x?.categoryId}>{x?.category}</option>
                          );
                        })
                      : ''}
                  </select>
                </div> */}

                <div class="form-group">
                  <label for="g-mb-about-company">
                    {t('About the Company')} <small>({t('Optional')})</small>
                  </label>
                  <textarea
                    class="form-control"
                    id="g-mb-about-company"
                    onChange={handleChange}
                    value={AirConditioningData.about}
                    name="about"
                    rows="2"
                  ></textarea>
                </div>

                <div className="form-group">
                  <label htmlFor="g-mb-location-map">
                    {t('Select Location on Map')}
                  </label>
                  <div className="input-group">
                    <input
                      name="location"
                      value={AirConditioningData?.location}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      id="g-mb-location-map"
                      readOnly
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleOpenMap}
                      >
                        <img
                          src="assets/images/icons/map-marker.svg"
                          alt="Map"
                          style={{ height: '20px', width: '20px' }}
                        />
                      </button>
                    </div>
                  </div>
                  <small className="form-text text-muted">
                    {t(
                      'Click to open the map and select your business location'
                    )}
                  </small>
                </div>
                <MapModal
                  open={mapModalOpen}
                  handleClose={handleCloseMap}
                  onLocationSelect={handleLocationSelect}
                  currentLocation={{
                    lat: AirConditioningData.gps?.lat,
                    long: AirConditioningData.gps?.long,
                    address: AirConditioningData?.location,
                  }}
                />

                <LogoCropModal
                  open={!!cropSrc}
                  imageSrc={cropSrc}
                  fileName={cropName}
                  onCancel={() => setCropSrc(null)}
                  onApply={uploadCroppedLogo}
                />

                <div class="form-group">
                  <label for="g-mb-website">
                    {t('Website')} <small>({t('Optional')})</small>
                  </label>
                  <input
                    name="website"
                    value={AirConditioningData.website}
                    onChange={handleChange}
                    type="text"
                    class="form-control"
                    id="g-mb-website"
                    placeholder={t("Website")}
                  />
                </div>

                <div class="form-group">
                  <h5>{t('Add Social Media Channels')}</h5>
                  <ul
                    class="list-inline mb-0 social-media-channel "
                    style={{ display: 'flex', flexDirection: 'column' }}
                  >
                    <li
                      class="list-inline-item mb-2 "
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/facebook.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="FACEBOOK"
                        value={AirConditioningData.socialMedia.FACEBOOK}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('facebook')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/instagram.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="INSTAGRAM"
                        value={AirConditioningData.socialMedia.INSTAGRAM}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('instagram')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/twitter.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="TWITTER"
                        value={AirConditioningData.socialMedia.TWITTER}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('twitter')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/youtube.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="YOUTUBE"
                        value={AirConditioningData.socialMedia.YOUTUBE}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('youtube')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/linkedin.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="LINKEDIN"
                        value={AirConditioningData.socialMedia.LINKEDIN}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('linkedin')}
                      />
                    </li>
                    <li
                      class="list-inline-item mb-2"
                      style={{ display: 'flex' }}
                    >
                      <a href="javascript:void(0);">
                        <img
                          src="assets/images/service-provider/snapchat.png"
                          alt=""
                        />
                      </a>
                      <input
                        name="SNAPCHAT"
                        value={AirConditioningData.socialMedia.SNAPCHAT}
                        onChange={mediaChange}
                        type="text"
                        class="form-control    col-10 m-3"
                        id="g-mb-website"
                        placeholder={t('snapchat')}
                      />
                    </li>
                  </ul>
                </div>

                <div class="row">
                  <div class="col-6">
                    <button
                      type="reset"
                      class="btn btn-secondary btn-block"
                      onClick={ResetHendler}
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      class="btn btn-warning btn-block"
                      // href='sp-air-conditioning-manage-business-packages.html'
                      // role='button'
                    >
                      {getAirConditioningList?.length ? t('Update') : t('Submit')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AirConditioningBusiness;
